import Vue from "vue";
import vuex from "vuex";
import router, { getRoleRoutes } from '../router';
import adminArr from '../constants/roles/administrator.json';
import artistArr from '../constants/roles/artist.json';
Vue.use(vuex);

const store = new vuex.Store({
    state: {
        ethAddress: "",
        ethChainID: "",
        web3: null,
        ethersprovider: null,
        roles: [],
        isSign: false,
    },
    mutations: {
        changeEthAddress(state, address) {
            state.ethAddress = address;
        },
        changeEthChainID(state, id) {
            state.ethChainID = id;
        },
        changeweb3(state, obj) {
            console.log('changeweb3');
            state.web3 = obj.web3;
            state.ethersprovider = obj.ethersprovider;
        },
        setRoles: (state, roles) => {
            state.roles = roles;
        },
        setIsSign(state, val) {
            state.isSign = val;
        }
    },
    actions: {
        async getEthChainID({ state, commit }) {
            try {
                const res = await state.web3.eth.getChainId();
                commit("changeEthChainID", res);
            } catch (error) {
                console.log(error);
            }
        },
        generateRoutes({ commit }, ethAddress) {
            const [isAdmin] = adminArr.filter(address => address.toUpperCase() === ethAddress.toUpperCase());
            const [isArtist] = artistArr.filter(address => address.toUpperCase() === ethAddress.toUpperCase());

            let accessRoutes = [];
            if (isAdmin) {
                commit('setRoles', ['admin', 'artist']);
                accessRoutes = getRoleRoutes('all');
            } else if (isArtist) {
                commit('setRoles', ['artist']);
                accessRoutes = getRoleRoutes('artist');
            } else {
                commit('setRoles', ['user']);
                accessRoutes = getRoleRoutes('user');
            }
            router.addRoutes(accessRoutes);
        }
    },
});
export default store;